import React from 'react';
import { useState, useEffect } from 'react'
import { Link } from 'react-router-dom';
import { db, user } from '../../../../firebase';
import PortfolioHeader from '../Header';

const About = () => {
    return (
        <>
            <PortfolioHeader />
            <div className="gearsBg">
                <div className="wheel8"></div>
                <div className="wheel9"></div>
                <div className="wheel10"></div>

            </div>
            <div className="paper">
                <div className="top">&nbsp;</div>
                <div className="mid clearfix">
                    <div className="leftnav">
                        <div class="intro-name">
                            <h1>Dinesh Garimella</h1>
                            <h4>Jack of all techs, master of none</h4>
                        </div> 
                        <div class="intro-name">
                            <span class="txt-14 thicker">CONTACT</span><br />
                            <p><span class="mdi mdi-email"></span> <a href="mailto:eastrosesun@gmail.com">eastrosesun@gmail.com </a></p>
                            <p><span class="mdi mdi-cellphone"></span> 9885122317</p>
                        </div>
                        
                       
                        {/* <div class="personal-details">
                            <span class="txt-14 thicker">PERSONAL DETAILS</span><br /><br />

                            <span class="txt-14 uppercase">Gender</span><br />
                            <span class="txt-16 thickest">Male</span><br /><br />
                            <span class="txt-14 uppercase">Date of Birth</span><br />
                            <span class="txt-16 thickest">10th Feb, 1978</span><br /><br />

                            <span class="txt-14 uppercase">MARTITAL STATUS</span><br />
                            <span class="txt-16 thickest">Married</span><br /><br />

                            <span class="txt-14 uppercase">LOCATION</span><br />
                            <span class="txt-16 thickest">Hyderabad, Telangana</span>
                        </div>
                        <hr /> */}
                    </div>

                    <div className="maincontent">
                    <div className="breadcrumb">
                        <Link to="/portfolio/home">Home</Link> » About Me
                    </div>
                    <p className="txt-30" style={{ lineHeight: '150%' }}>I am a passionate full stack designer/developer who loves  wearing multiple hats, I am experienced in creating user interfaces that have beauty with brains.</p>

                    <div className="tech-stack">
                        <div className="tech-stack-name" style={{ background: '#fffff6' }}>React</div>
                        <div className="tech-stack-name" style={{ background: '#f7fdff' }}>Javascript</div>
                        <div className="tech-stack-name" style={{ background: '#fdf6ff' }}>HTML/CSS</div>
                        <div className="tech-stack-name" style={{ background: '#fff6fb' }}>Angular</div>
                        <div className="tech-stack-name" style={{ background: '#f4f0ff' }}>Flutter</div>
                        <div className="tech-stack-name" style={{ background: '#e7fff0' }}>UI/UX</div>
                        <div className="tech-stack-name" style={{ background: '#fffff6' }}>Django</div>
                        <div className="tech-stack-name" style={{ background: '#fdf6ff' }}>Python</div>
                        <div className="tech-stack-name" style={{ background: '#fffff6' }}>PHP</div>
                        <div className="tech-stack-name" style={{ background: '#ffdcda' }}>MySQL</div>
                        <div className="tech-stack-name" style={{ background: '#fffff6' }}>Firebase</div>
                        <div className="tech-stack-name" style={{ background: '#e7fff0' }}>RESTful APIs</div>
                        <div className="tech-stack-name" style={{ background: '#fff6fb' }}>NodeJs</div>
                        <div className="tech-stack-name" style={{ background: '#fffff6' }}>Ionic (Mobile)</div>
                    </div>

                    <ul class="txt-18">
                        <span className="txt-18 thicker"><span class="mdi mdi-trophy-award"></span> Awards</span>
                        <li><span class="mdi mdi-trophy"></span> AT&T - Service Excellence Award - 2010</li>
                        <li><span class="mdi mdi-trophy"></span> AT&T - White Acre Award - 2010</li>
                        <li><span class="mdi mdi-trophy"></span> AT&T - Connection Award - 3rd Quarter, 2021</li>

                        <li><span class="mdi mdi-trophy"></span> AT&T - Connection Award - 1st Quarter, 2022</li>
                    </ul>

                    <div class="section-header">
                        <span class="mdi mdi-receipt"></span> Roles & Responsibilities<br /><br />
                    </div>
                    <div class="work-experience">
                        <span class="highlight-purple"><strong>FRONT END (5+ years)</strong></span>
                        <ul>
                            <li>Develop front-end applications using tech stack like React, Angular, NodeJS, Flutter, HTML/CSS/jQuery to create a unique & intuitive user experience.</li>
                            <li>Experience with creating modular, reusable components that are scalable & easy to test.</li>
                            <li>Experience with responsive web design, media queries and delivering functionality that works with range of client devices/browsers from desktops and laptops to</li>
                            <li>Experience with Defining, Ideating, Prototyping & Transforming phases of a web application life cycle.</li>
                            <li>Well versed with state & data management in SPAs.</li>
                            <li>Passionate to learn new techstack/frameworks.</li>
                        </ul>
                    </div> 
                    <div class="work-experience">
                        <span class="highlight-purple"><strong>UI/UX (4 years)</strong></span>
                        <ul>
                            <li>Brainstorm & gather requirements from different stakeholders.</li>
                            <li>Experienced with Defining, Ideating, Prototyping & Transforming phases of a UI/UX design.</li>
                            <li>Experienced working with design tools like Photoshop & Figma.</li>
                            <li>Experienced with creating wireframes, prototypes, mockups to capture business requirements accurately.</li>
                        </ul>
                    </div> 
                    <div class="work-experience">
                        <span class="highlight-purple"> <strong>MIDDLEWARE (3 years)</strong></span>
                        <ul>
                            <li>Proficiency in developing REST-ful APIs for web applications.</li>
                            <li>Having excellent knowledge developing Authorization & Authentication techniques.</li>
                            <li>Having fair knowledge in caching & securing the web application with session management. .
                            </li>
                            <li>Created a light-weight MVC framework using classic PHP.
                            </li>
                            <li>Worked extensively with Python (using frameworks like Django & Flask) for creating REST-ful APIs, Webscraping, File upload, & Automation.</li>
                        </ul>
                    </div><br /><br />
                </div>
                </div> 
                
            </div>
            <div className="btm">&nbsp;</div> 
        </>
    )

}
export default About;